var React = require('react');

function PathLinkInline (props) {
    return React.createElement("svg",props,React.createElement("symbol",{"viewBox":"0 0 44 44","id":"path"},React.createElement("path",{"d":"M22,22 L2,22 C2,11 11,2 22,2 C33,2 42,11 42,22"})));
}

PathLinkInline.defaultProps = {"style":{"display":"none"}};

module.exports = PathLinkInline;

PathLinkInline.default = PathLinkInline;
